import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import TeamsEndpointAuditTable from "./TeamsEndpointAuditTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const TeamsEndpointAudit = () => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    teamsEndpointAudits: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/TeamsEndpointAudit/")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          teamsEndpointAudits: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <>
          <div className={classes.loading}>
            <CircularProgress />
          </div>
        </>
      ) : (
        <div className={classes.table}>
          <TeamsEndpointAuditTable
            endpointAudits={dataObj.teamsEndpointAudits}
          />
        </div>
      )}
    </>
  );
};
export default TeamsEndpointAudit;
